import { Subject } from 'rxjs/Rx'

import { ITimer } from '../timer.interface'

export class NullTimer implements ITimer {

  public currentTime: number
  public elapsedTime: number
  public timeOut: Subject<void> = new Subject<void>()
  public timeUpdate: Subject<void> = new Subject<void>()

  public start() {
    return new Subject<void>()
  }

  public pause() {}
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/timers/null-timer/null-timer.ts